var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import { BAlert, BCard, BTab, BTabs } from "bootstrap-vue";
import { useFileSources } from "@/composables/fileSources";
import { faArchive } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { RouterLink } from "vue-router";
import HistoryArchiveExportSelector from "@/components/History/Archiving/HistoryArchiveExportSelector.vue";
import HistoryArchiveSimple from "@/components/History/Archiving/HistoryArchiveSimple.vue";
import { useHistoryStore } from "@/stores/historyStore";
import LoadingSpan from "@/components/LoadingSpan.vue";
import { useConfig } from "@/composables/config";
import { useToast } from "@/composables/toast";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryArchiveWizard',
    props: {
        historyId: null
    },
    setup(__props) {
        const props = __props;
        library.add(faArchive);
        const historyStore = useHistoryStore();
        const { config } = useConfig(true);
        const toast = useToast();
        const { hasWritable: hasWritableFileSources } = useFileSources();
        const isArchiving = ref(false);
        const history = computed(() => {
            const history = historyStore.getHistoryById(props.historyId);
            if (history === null) {
                // It could be already an archived history, so we won't find it in the store
                // as it's not in the active histories anymore.
                historyStore.loadHistoryById(props.historyId);
                return historyStore.getHistoryById(props.historyId);
            }
            return history;
        });
        const isHistoryAlreadyArchived = computed(() => {
            var _a;
            return (_a = history.value) === null || _a === void 0 ? void 0 : _a.archived;
        });
        const canFreeStorage = computed(() => {
            return hasWritableFileSources.value && config.value.enable_celery_tasks;
        });
        const archivedHistoriesRoute = "/histories/archived";
        function onArchiveHistory(exportRecordId) {
            return __awaiter(this, void 0, void 0, function* () {
                isArchiving.value = true;
                try {
                    const shouldPurge = exportRecordId !== undefined;
                    yield historyStore.archiveHistoryById(props.historyId, exportRecordId, shouldPurge);
                    toast.success("History archived successfully.");
                }
                catch (error) {
                    toast.error(`The history archive request failed. Please try again later. Reason: ${error}`);
                }
                finally {
                    isArchiving.value = false;
                }
            });
        }
        return { __sfc: true, historyStore, config, toast, hasWritableFileSources, props, isArchiving, history, isHistoryAlreadyArchived, canFreeStorage, archivedHistoriesRoute, onArchiveHistory, BAlert, BCard, BTab, BTabs, FontAwesomeIcon, RouterLink, HistoryArchiveExportSelector, HistoryArchiveSimple, LoadingSpan };
    }
});
